import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { QueryResultsModel } from '../../_base/crud';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ImpersonationService {
  constructor(private http: HttpClient) {}
  getUsers(term?: string): Observable<any> {
    const url = `${environment.USER_BASE}/autocomplete-user?is_active=true&term=${term}`;
    return this.http.get<QueryResultsModel>(url);
  }
}
